import React, { useEffect } from "react";
import Compensation from "../../../images/Compensation.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DropdownComponent from "../../../containers/Dropdown";
import { POSTAL_CODE_PLACEHOLDER, PROVINCEDRPDATA, STDLTDDRPDATA } from "../../../App.config";
import backArrow from "../../../images/back-arrow.svg";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import moment from "moment";
import UploadSvg from "../../../images/upload.svg";
import AttachmentTable from "../../Std/AttachmentTable";
import DisplayEmployeeBlock from "../../Std/DisplayEmployeeBlock";
import { Fragment } from "react";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";

const JobDescription = ({
  onStdLtdDropdownChange,
  onStdLtdDateChange,
  addMoreElement,
  removeElement,
  state,
  onSubmit,
  previousStep,
  props,
  handleChanges,
  download,
  handleFileUpload,
  addDescription,
  removeFile,
  attachmentRef,
  onDateChange,
  handlePhoneNumber,
  onDropDownChange,
  resetAirApplicationUrl,
}) => {
  useEffect(() => {
    // if (state.declaration.ref.current.focus) {
    //   state.declaration.ref.current.focus();
    // }
  }, []);
  // Set air pdf url to initial state
  // useEffect(() => {
  //   resetAirApplicationUrl();
  // }, []);

  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t(
                    "ACCOMODATION-Job-Description.form.heading.text"
                  )}
                </span>
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                {/* <h2 className="Sub-Heading">
                  <span>
                    Job Description
                  </span>
                </h2> */}
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo pb-0">
                      <label htmlFor="">
                        {props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Job.Description"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="Check-box">
                      <div>
                        <input
                          className="styled-checkbox"
                          type="checkbox"
                          id="jobDescAttach"
                          name="jobDescAttach"
                          onChange={handleChanges}
                          checked={state.jobDescAttach.value}
                          ref={state.jobDescAttach.ref}
                        />
                        <label htmlFor="jobDescAttach">
                          <span>
                            {props.context.t(
                              "ACCOMODATION-Job-Description.form.label.text.Job.JobDescAttach"
                            )}
                          </span>
                        </label>
                        <span className="error">{state.jobDescAttach.error}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="jobDescription"
                        value={state.jobDescription.value}
                        onChange={handleChanges}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Employee.request.accomodation"
                        )}
                      </label>
                      <ToggleComponent
                        name="employeeRequest"
                        isActive={state.employeeRequest.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Request.Toggle.Yes"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Request.Toggle.No"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.employeeRequest.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                              )}
                              name="ifRequest"
                              value={state.ifRequest.value}
                              ref={state.ifRequest.ref}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Accomodation.Solution"
                        )}
                      </label>
                      <ToggleComponent
                        name="solution"
                        isActive={state.solution.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Solution.Toggle.Yes"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "ACCOMODATION-Job-Description.form.label.text.Solution.Toggle.No"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.solution.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                              )}
                              name="ifCommon"
                              value={state.ifCommon.value}
                              ref={state.ifCommon.ref}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 ">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "CCM-STEP3-SummaryOfDaysAbsent"
                        )}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "CCM-STEP3-SummaryOfDaysAbsent"
                        )}
                        name="summaryOfDaysAbsent"
                        value={state.summaryOfDaysAbsent.value}
                        onChange={handleChanges}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 ">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "CCM-STEP3-CurrentClaimStatus"
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "CCM-STEP3-CurrentClaimStatus"
                        )}
                        name="currentClaimStatus"
                        value={state.currentClaimStatus.value}
                        ref={state.currentClaimStatus.ref}
                        onChange={handleChanges}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "CCM-STEP3-QUE1"
                        )}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="filePurposeReview"
                        value={state.filePurposeReview.value}
                        onChange={handleChanges}
                      />

                      {state.filePurposeReview?.error && (
                        <span className="error">{state.filePurposeReview.error}</span>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group Ctm-rdo">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Ques3.1"
                            )}
                          </label>
                        </div>
                      </div>
                      {state.previousStdLtd.value.map((element, index) => (
                        <Fragment key={index}>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "STD-Employer-Statement.form.Absence-Details.label.text.Type-Of-Cases"
                                )}
                              </label>
                              <br />
                              <DropdownComponent
                                name="stdLtd"
                                id="stdLtd"
                                options={STDLTDDRPDATA}
                                isMultiSelect={false}
                                option_key="stdLtdId"
                                option_display="stdLtdName"
                                onChange={(e) => {
                                  onStdLtdDropdownChange(e, index);
                                }}
                                values={element.stdLtd}
                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                selectAllText="Select All Options"
                                isSearchOption={true}
                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                            <div className="form-group Date-feild">
                              <label htmlFor="">
                                {props.context.t(
                                  "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Cases"
                                )}
                                {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                              </label>
                              <CustomDatePicker
                                //maxDate={moment().toDate()}
                                id="stdLtdDate"
                                max
                                selected={element.stdLtdDate}
                                onChange={(e) => {
                                  onStdLtdDateChange(e, "stdLtdDate", index);
                                }}
                                placeholderText={props.context.t(
                                  "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Cases"
                                )}
                                className="form-control"
                                yearDropdown={5}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                            <div className="form-group Date-feild">
                              <label htmlFor="">
                                {props.context.t(
                                  "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                                )}
                                {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                              </label>
                              <CustomDatePicker
                                id="stdLtdRtwDate"
                                selected={element.stdLtdRtwDate}
                                onChange={(e) => {
                                  onStdLtdDateChange(e, "stdLtdRtwDate", index);
                                }}
                                placeholderText={props.context.t(
                                  "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                                )}
                                className="form-control"
                                yearDropdown={5}
                              />
                            </div>
                          </div>
                          {!element.default && (
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                              <input
                                type="button"
                                className="btn btn-danger margin-top-28"
                                onClick={(e) => {
                                  e.preventDefault();
                                  removeElement(index);
                                }}
                                value={props.context.t(
                                  "STD-Employer-Statement.form.button.remove"
                                )}
                              />
                            </div>
                          )}
                        </Fragment>
                      ))}
                      <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                        <input
                          type="button"
                          className="btn btn-primary margin-top-28"
                          onClick={(e) => {
                            e.preventDefault();
                            addMoreElement();
                          }}
                          value={props.context.t(
                            "STD-Employer-Statement.form.button.add-More"
                          )}
                        />
                      </div>
                      {/* 

                          {/* {state.isObservedChanges?.error && (
                              <span className="error">
                                {state.isObservedChanges.error}
                              </span>
                            )} */}
                    </div>
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "CCM-STEP3-QUE3"
                        )}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="changeInProductivityOrQualityOfWork"
                        value={state.changeInProductivityOrQualityOfWork.value}
                        onChange={handleChanges}
                      />

                      {/* {state.isObservedChanges?.error && (
                              <span className="error">
                                {state.isObservedChanges.error}
                              </span>
                            )} */}
                    </div>
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "CCM-STEP3-QUE4"
                        )}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="issueMayAffectPerformance"
                        value={state.issueMayAffectPerformance.value}
                        onChange={handleChanges}
                      />

                      {/* {state.isObservedChanges?.error && (
                              <span className="error">
                                {state.isObservedChanges.error}
                              </span>
                            )} */}
                    </div>

                    <div>
                      <div className="form-group Ctm-rdo">
                        <label htmlFor="">
                          {props.context.t(
                            "ACCOMODATION-Job-Description.form.label.text.Solution.Toggle.Clarification.from.Employer"
                          )}
                        </label>
                      </div>
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder={props.context.t(
                            "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="detail1"
                          value={state.detail1.value}
                          onChange={handleChanges}
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder={props.context.t(
                            "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="detail2"
                          value={state.detail2.value}
                          onChange={handleChanges}
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder={props.context.t(
                            "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="detail3"
                          value={state.detail3.value}
                          onChange={handleChanges}
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder={props.context.t(
                            "ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="detail4"
                          value={state.detail4.value}
                          onChange={handleChanges}
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Additional Information */}
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading8.text"
                    )}
                  </span>
                </h2>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="form-group">
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder=""
                      name="additionalNotesAdd"
                      value={state.additionalNotesAdd.value}
                      onChange={handleChanges}
                    />
                    {state.additionalNotesAdd?.error && (
                      <span className="error">
                        {state.additionalNotesAdd.error}
                      </span>
                    )}
                  </div>
                </div>


                {
                  // state.jobDescAttach.value &&
                  <div className="row">
                    <div className="col-xl-4 col-md-6 col-12">
                      <div className="form-group">
                        <label htmlFor="">{props.context.t("STD-Employer-Statement.form.subheading6.text")}</label>
                        <div className="upload-btn-wrapper form-control">
                          <button tabIndex="-1" className="upload-btn">
                            <img tabIndex="-1" src={UploadSvg} alt="" />
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.label.text.Upload"
                            )}
                          </button>
                          <input
                            onChange={handleFileUpload}
                            type="file"
                            tabIndex="-1"
                            name="attachment"
                            ref={attachmentRef}
                          />
                        </div>
                        <small>
                          {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.File-Format"
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                }
                <div className="form-group">
                  {Array.isArray(props.attachment) &&
                    props.attachment.length ? (
                    <AttachmentTable
                      attachment={props.attachment}
                      download={download}
                      removeFile={removeFile}
                      addDescription={addDescription}
                    />
                  ) : null}
                </div>
                <div className="Check-box">
                  <div>
                    <input
                      className="styled-checkbox"
                      type="checkbox"
                      id="declaration"
                      name="declaration"
                      onChange={handleChanges}
                      checked={state.declaration.value}
                      ref={state.declaration.ref}
                    />
                    <label htmlFor="declaration">
                      <span>
                        {props.context.t(
                          "CCM-Description.form.label.text.Declaration"
                        )}
                      </span>
                    </label>
                    <span className="error">{state.declaration.error}</span>
                  </div>
                </div>


                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    onClick={() => onSubmit(true, false)}
                    className={
                      state.declaration.value
                        ? "btn btn-primary"
                        : "btn btn-primary disabled"
                    }
                  >
                    {props.context.t(
                      "ACCOMODATION-Job-Description.form.button.save"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default JobDescription;
